module.exports = __webpack_public_path__ + "img/xc_3d_sp.fa3ae126.png";